
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail-investor/business-model",
      function () {
        return require("private-next-pages/retail-investor/business-model.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retail-investor/business-model"])
      });
    }
  